import { render, staticRenderFns } from "./FlowDetail.vue?vue&type=template&id=b1bc311c&scoped=true&lang=html&"
import script from "./FlowDetail.vue?vue&type=script&lang=coffee&"
export * from "./FlowDetail.vue?vue&type=script&lang=coffee&"
import style0 from "./FlowDetail.vue?vue&type=style&index=0&id=b1bc311c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1bc311c",
  null
  
)

component.options.__file = "FlowDetail.vue"
export default component.exports